exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".byo-selection{padding-bottom:40px}.byo-selection .radio-button{padding:5px 25px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/BringYourOwnModem/BringYourOwnModem.scss
 ** module id = 1206
 ** module chunks = 0
 **/